import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>HeroPixelLab - Premium Online Dataspill</title>
        <meta name="description" content="HeroPixelLab - premium nettbutikk for online dataspill. Oppdag eksklusive spill, digitale nøkler og unike samleobjekter." />
        <link href="https://heropixellab.com/terms-conditions/" rel="canonical"/>
      </Helmet>

      <div className="terms-conditions">
      <h1>Vilkår og betingelser</h1>
      <p className="last-updated">Sist oppdatert: 1. januar 2025</p>

      <section>
        <h2>1. Innledning</h2>
        <p>
          Velkommen til HeroPixelLab. Disse vilkårene og betingelsene regulerer din bruk av vår nettbutikk og kjøp av våre produkter og tjenester. Ved å bruke vår nettside eller foreta kjøp, godtar du disse vilkårene. Vi oppfordrer deg til å lese vilkårene nøye før du foretar et kjøp.
        </p>
      </section>

      <section>
        <h2>2. Avtaleparter</h2>
        <p>
          Disse vilkårene er inngått mellom:
          - <strong>HeroPixelLab AS</strong> (org. nr. 123 456 789), heretter kalt "vi", "oss" eller "selger"
          - <strong>Deg</strong> som kunde, heretter kalt "du", "deg" eller "kjøper"
        </p>
        <p>
          Ved å fullføre en bestilling bekrefter du at du er minst 18 år, eller handler med foresattes samtykke.
        </p>
      </section>

      <section>
        <h2>3. Produkter og tjenester</h2>
        <p>
          Vi tilbyr følgende typer produkter:
        </p>
        <ul>
          <li><strong>Digitale spillnøkler</strong> – leveres via e-post etter kjøp</li>
          <li><strong>Digitale produkter</strong> – nedlasting via din brukerkonto</li>
          <li><strong>Fysiske produkter</strong> – sendes til din oppgitte adresse</li>
          <li><strong>Samleobjekter</strong> – leveres med frakt etter lokale regler</li>
        </ul>
        <p>
          Alle digitale produkter leveres digitalt. Fysiske produkter kan ha begrenset tilgjengelighet avhengig av lagerstatus og leveringsområde.
        </p>
      </section>

      <section>
        <h2>4. Bestilling og avtaleinngåelse</h2>
        <h3>4.1 Bestillingsprosess</h3>
        <ol>
          <li>Du velger produkter og legger dem i handlekurven</li>
          <li>Du oppgir nødvendige opplysninger (navn, e-post, adresse)</li>
          <li>Du velger betalingsmetode og godkjenner betalingen</li>
          <li>Du mottar en ordrebekreftelse på e-post</li>
          <li>Kjøpsavtalen er inngått når betalingen er bekreftet</li>
        </ol>

        <h3>4.2 Angrerett og angrefrist</h3>
        <p>For digitale produkter:</p>
        <ul>
          <li>Angreretten gjelder ikke når levering av digitalt innhold har startet</li>
          <li>Når spillnøkkelen er levert, anses avtalen som oppfylt</li>
          <li>Som forbruker har du ikke angrerett på digitale leveranser som er påbegynt</li>
        </ul>
        <p>For fysiske produkter:</p>
        <ul>
          <li>14 dagers angrerett fra mottak av varen</li>
          <li>Varen må returneres i original emballasje og stand</li>
          <li>Fraktkostnader for retur dekkes av kunden</li>
        </ul>
      </section>

      <section>
        <h2>5. Priser og betaling</h2>
        <h3>5.1 Priser</h3>
        <ul>
          <li>Alle priser er oppgitt i NOK inkl. mva. med mindre annet er angitt</li>
          <li>Prisene inkluderer eventuelle digitale avgifter</li>
          <li>Forbehold om prisendringer fram til avtale er inngått</li>
          <li>Kampanjepriser gjelder kun i kampanjeperioden</li>
        </ul>

        <h3>5.2 Betalingsmetoder</h3>
        <ul>
          <li>Kortbetaling (Visa, Mastercard, American Express)</li>
          <li>Vipps</li>
          <li>Klarna (faktura/delbetaling for kvalifiserte kunder)</li>
          <li>PayPal</li>
          <li>Eventuelle andre metoder som er tilgjengelige i kassen</li>
        </ul>

        <h3>5.3 Betalingsbetingelser</h3>
        <ul>
          <li>Betaling skjer ved bestilling</li>
          <li>For faktura: betalingsfrist 14 dager</li>
          <li>Forsinket betaling medfører purregebyr og forsinkelsesrenter</li>
          <li>Vi forbeholder oss retten til å bekrefte betalingen før levering</li>
        </ul>
      </section>

      <section>
        <h2>6. Levering</h2>
        <h3>6.1 Digitale produkter</h3>
        <ul>
          <li>Levering skjer normalt innen 24 timer etter bekreftet betaling</li>
          <li>Spillnøkler sendes til registrert e-postadresse</li>
          <li>Enkelte produkter leveres via din brukerkonto</li>
          <li>Ved teknisk svikt refunderes kjøpet</li>
        </ul>

        <h3>6.2 Fysiske produkter</h3>
        <ul>
          <li>Forventet leveringstid er 3-7 virkedager</li>
          <li>Levering skjer til oppgitt leveringsadresse</li>
          <li>Fraktkostnader oppgis i handlekurven før betaling</li>
          <li>Eventuelle forsinkelser meldes via e-post</li>
        </ul>
      </section>

      <section>
        <h2>7. Brukerkonto</h2>
        <h3>7.1 Registrering</h3>
        <ul>
          <li>Du kan opprette en brukerkonto på vår nettside</li>
          <li>Du er ansvarlig for å holde dine innloggingsdetaljer hemmelige</li>
          <li>Du må gi korrekte og oppdaterte opplysninger</li>
          <li>Kontoen er personlig og kan ikke overdras</li>
        </ul>

        <h3>7.2 Sikkerhet</h3>
        <ul>
          <li>Du plikter å varsle oss om uautorisert bruk av kontoen din</li>
          <li>Vi kan stenge kontoen ved mistanke om misbruk</li>
          <li>Du er selv ansvarlig for aktivitet på din konto</li>
          <li>Vi anbefaler sterke passord og tofaktorautentisering</li>
        </ul>
      </section>

      <section>
        <h2>8. Bruk av digitale produkter</h2>
        <h3>8.1 Lisensvilkår</h3>
        <ul>
          <li>Kjøpte spillnøkler er for personlig bruk</li>
          <li>Det er ikke tillatt å videreselge eller overføre nøkler</li>
          <li>Enkelte spill har spesifikke lisensbetingelser fra utgiveren</li>
          <li>Du må følge spillutgiverens bruksvilkår</li>
        </ul>

        <h3>8.2 Tekniske krav</h3>
        <ul>
          <li>Du er selv ansvarlig for å ha nødvendig utstyr og programvare</li>
          <li>Kjøp gjøres på eget ansvar vedrørende systemkrav</li>
          <li>Vi gir ingen garanti for spesifikke systemer</li>
        </ul>
      </section>

      <section>
        <h2>9. Reklamasjon og garantier</h2>
        <h3>9.1 Reklamasjonsfrist</h3>
        <ul>
          <li>Reklamasjon må fremsettes innen rimelig tid etter at mangelen er oppdaget</li>
          <li>For forbrukskjøp: reklamasjon innen 2 år</li>
          <li>For digitale produkter: reklamasjon innen 1 år</li>
        </ul>

        <h3>9.2 Mangler ved digitale produkter</h3>
        <ul>
          <li>Ikke-fungerende nøkler erstattes</li>
          <li>Feil produkt refunderes</li>
          <li>Kunden må dokumentere feilen</li>
          <li>Refusjon skjer innen 14 dager</li>
        </ul>

        <h3>9.3 Mangler ved fysiske produkter</h3>
        <ul>
          <li>Skadde varer erstattes eller repareres</li>
          <li>Feil i levering rettes opp</li>
          <li>Kunden har krav på prisavslag eller heving i henhold til forbrukerkjøpsloven</li>
        </ul>
      </section>

      <section>
        <h2>10. Ansvarsbegrensning</h2>
        <ul>
          <li>Vi er ikke ansvarlige for indirekte skader som følge av ditt bruk av nettsiden</li>
          <li>Vi er ikke erstatningsansvarlige for tredjeparts handlinger</li>
          <li>Vårt erstatningsansvar er begrenset til kjøpesummen for de aktuelle produktene</li>
          <li>Force majeure fritar oss fra ansvar ved uforutsette hendelser</li>
        </ul>
      </section>

      <section>
        <h2>11. Immaterielle rettigheter</h2>
        <ul>
          <li>Alle varemerker og logoer tilhører rettighetshaverne</li>
          <li>Det er ikke tillatt å kopiere vårt innhold uten tillatelse</li>
          <li>Bruk av vår nettside gir ingen rettigheter til våre varemerker</li>
        </ul>
      </section>

      <section>
        <h2>12. Force majeure</h2>
        <p>
          Vi er ikke ansvarlige for forsinkelser eller manglende oppfyllelse som skyldes hendelser utenfor vår kontroll, herunder men ikke begrenset til naturkatastrofer, krig, streik, pandemier, eller myndighetspåbud.
        </p>
      </section>

      <section>
        <h2>13. Endring av vilkår</h2>
        <p>
          Vi forbeholder oss retten til å oppdatere disse vilkårene. Ved vesentlige endringer vil vi varsle deg via e-post eller med fremtredende melding på nettsiden minst 30 dager før endringene trer i kraft.
        </p>
      </section>

      <section>
        <h2>14. Tvister og lovvalg</h2>
        <ul>
          <li>Disse vilkårene er underlagt norsk rett</li>
          <li>Tvister søkes løst gjennom forhandlinger og minnelig ordning</li>
          <li>Du kan klage til Forbrukertilsynet eller Forbrukertvistutvalget</li>
          <li>Vernetinger: Oslo tingrett, med mindre annet følger av ufravikelig lovgivning</li>
        </ul>
        <p>
          Klageorganer:
          Forbrukertilsynet – www.forbrukertilsynet.no
          Forbrukertvistutvalget – www.forbrukertvistutvalget.no
          EU-kommisjonens klageportal – ec.europa.eu/consumers/odr
        </p>
      </section>

      <section>
        <h2>15. Kontaktinformasjon</h2>
        <ul>
          <li>E-post: heropixellab@hotmail.com</li>
          <li>Telefon: +4738172040</li>
          <li>Brev: HeroPixelLab AS, Kirkegata 15, 4611 Kristiansand, Norge</li>
        </ul>
      </section>

      <p className="policy-footer">© 2025 HeroPixelLab. Alle rettigheter forbeholdt.</p>
    </div>
  
    </>);
};

export default TermsConditions;